<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    type="list"
    :pagination="{
      count: tableData.count,
      current: +$route.query.p,
      request: 'geofences/',
    }"
    @tableData="tableData = $event"
    @loading="loading = $event"
  >
    <tableSearch
      @search="search = $event"
      :placeholder="
        $t('SEARCH_FOR', {
          type: $t('TITLE'),
        })
      "
    />

    <el-table
      :empty-text="$t('NO_DATA')"
      :data="
        tableData.results.filter(
          (data) => !search || data.title.includes(search)
        )
      "
      v-loading="loading"
      :stripe="true"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="title"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('TITLE')"
        width="160"
      >
        <template slot-scope="scope">
          <div :data-title="$t('TITLE')" class="flex">
            {{ scope.row.title }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="" width="170">
        <template slot-scope="scope">
          <div class="fixed-column">
            <tableFeatures
              :router="{
                name: 'EDIT_GEOFENCE',
                id: scope.row.id,
              }"
              :title="$t('GEOFENCE')"
              @open="open($event)"
              :isDeleteable="false"
              @view="view($event, 'VIEW_GEOFENCE')"
              :view="true"
            ></tableFeatures>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </Content>
</template>

<script>
import { allFences } from '@/api/fence'
import tableSearch from '@/components/elements/tableSearch'
import tableFeatures from '@/components/elements/tableFeatures'
import { open } from '@/mixins/openDesc'
import { view } from '@/mixins/viewPage'
export default {
  mixins: [open, view],
  data() {
    return {
      tableData: {
        results: [],
      },
      search: '',
      loading: true,
    }
  },

  mounted() {
    allFences.api().then((res) => {
      if (res) {
        this.tableData = res
      }
      this.loading = false
    })
  },
  components: {
    tableSearch,
    tableFeatures,
  },
}
</script>
